// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const CreditCard = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M81.118 72.299H14.882a2.385 2.385 0 0 1-2.383-2.383V43.703h71.002v26.215a2.385 2.385 0 0 1-2.383 2.382M14.882 23.7h66.236a2.385 2.385 0 0 1 2.383 2.383V31.7H12.499v-5.617a2.385 2.385 0 0 1 2.383-2.383m66.236-4H14.882a6.39 6.39 0 0 0-6.383 6.383v43.832a6.39 6.39 0 0 0 6.383 6.383h66.236a6.39 6.39 0 0 0 6.383-6.383V26.084a6.39 6.39 0 0 0-6.383-6.383"
			fillRule="evenodd"
		/>
	</svg>
);
export default CreditCard;
